<template>
  <section>
    <!-- Chat Widget -->
    <chat-widget ref="chatWidget" v-if="isLoggedIn" @unreadCount="unread" />
    <!-- Layout -->
    <component :is="layout">
      <router-view />
    </component>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import NONAV from '@/layouts/no-nav'
import DEFAULT from '@/layouts/default'
import SIDENAV from '@/layouts/side-nav'
import ChatWidget from '@/components/chat/ChatWidget'

const options = {
  NONAV,
  DEFAULT,
  SIDENAV
}

export default {
  name: 'layout-broker',
  components: {
    ChatWidget
  },
  props: {
    name: String
  },
  mounted() {
    this.$eventBus.$on('show-chat', this.showChat)
  },
  computed: {
    ...mapGetters('auth', ['profile']),
    isLoggedIn() {
      let _is = false
      if (this.profile) {
        _is = true
      }
      return _is
    },
    layout() {
      let component = options[this.name.toUpperCase().replace(/\W/g, '')]
      return component || NONAV
    }
  },
  methods: {
    unread(count) {
      console.log('Unread', count)
    },
    showChat(data) {
      console.log('Show Chat', data)
      this.$refs.chatWidget.showChat(data)
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('show-chat')
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/broker.vue